/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PProviderTokenRouteImport } from './routes/p/$providerToken'
import { Route as TokenChannelRouteImport } from './routes/$token.$channel'
import { Route as TokenChannelIndexRouteImport } from './routes/$token.$channel.index'
import { Route as TokenChannelStatementDetailsRouteImport } from './routes/$token.$channel.statement-details'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PProviderTokenRoute = PProviderTokenRouteImport.update({
  id: '/p/$providerToken',
  path: '/p/$providerToken',
  getParentRoute: () => rootRouteImport,
} as any)
const TokenChannelRoute = TokenChannelRouteImport.update({
  id: '/$token/$channel',
  path: '/$token/$channel',
  getParentRoute: () => rootRouteImport,
} as any)
const TokenChannelIndexRoute = TokenChannelIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TokenChannelRoute,
} as any)
const TokenChannelStatementDetailsRoute =
  TokenChannelStatementDetailsRouteImport.update({
    id: '/statement-details',
    path: '/statement-details',
    getParentRoute: () => TokenChannelRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$token/$channel': typeof TokenChannelRouteWithChildren
  '/p/$providerToken': typeof PProviderTokenRoute
  '/$token/$channel/statement-details': typeof TokenChannelStatementDetailsRoute
  '/$token/$channel/': typeof TokenChannelIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/p/$providerToken': typeof PProviderTokenRoute
  '/$token/$channel/statement-details': typeof TokenChannelStatementDetailsRoute
  '/$token/$channel': typeof TokenChannelIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$token/$channel': typeof TokenChannelRouteWithChildren
  '/p/$providerToken': typeof PProviderTokenRoute
  '/$token/$channel/statement-details': typeof TokenChannelStatementDetailsRoute
  '/$token/$channel/': typeof TokenChannelIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$token/$channel'
    | '/p/$providerToken'
    | '/$token/$channel/statement-details'
    | '/$token/$channel/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/p/$providerToken'
    | '/$token/$channel/statement-details'
    | '/$token/$channel'
  id:
    | '__root__'
    | '/'
    | '/$token/$channel'
    | '/p/$providerToken'
    | '/$token/$channel/statement-details'
    | '/$token/$channel/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  TokenChannelRoute: typeof TokenChannelRouteWithChildren
  PProviderTokenRoute: typeof PProviderTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/$providerToken': {
      id: '/p/$providerToken'
      path: '/p/$providerToken'
      fullPath: '/p/$providerToken'
      preLoaderRoute: typeof PProviderTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$token/$channel': {
      id: '/$token/$channel'
      path: '/$token/$channel'
      fullPath: '/$token/$channel'
      preLoaderRoute: typeof TokenChannelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$token/$channel/': {
      id: '/$token/$channel/'
      path: '/'
      fullPath: '/$token/$channel/'
      preLoaderRoute: typeof TokenChannelIndexRouteImport
      parentRoute: typeof TokenChannelRoute
    }
    '/$token/$channel/statement-details': {
      id: '/$token/$channel/statement-details'
      path: '/statement-details'
      fullPath: '/$token/$channel/statement-details'
      preLoaderRoute: typeof TokenChannelStatementDetailsRouteImport
      parentRoute: typeof TokenChannelRoute
    }
  }
}

interface TokenChannelRouteChildren {
  TokenChannelStatementDetailsRoute: typeof TokenChannelStatementDetailsRoute
  TokenChannelIndexRoute: typeof TokenChannelIndexRoute
}

const TokenChannelRouteChildren: TokenChannelRouteChildren = {
  TokenChannelStatementDetailsRoute: TokenChannelStatementDetailsRoute,
  TokenChannelIndexRoute: TokenChannelIndexRoute,
}

const TokenChannelRouteWithChildren = TokenChannelRoute._addFileChildren(
  TokenChannelRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  TokenChannelRoute: TokenChannelRouteWithChildren,
  PProviderTokenRoute: PProviderTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
